// import { SplitCellsOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { getRequiredErrorMessage } from "../../../../libs/form";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

type ReceiptAmountFormValues = {
  receiptTotalAmount: number;
};

type ReceiptAmountSectionProps = {
  receiptTotalAmount: number;
  applyOverpaymentCredit?: boolean;
  tenantName?: string;
  disabled?: boolean;
  onReceiptTotalChange: (amount: number) => void;
  onAutoDistribute: (amount: number) => void;
};

export const ReceiptAmountSection: React.FC<ReceiptAmountSectionProps> = ({
  receiptTotalAmount,
  applyOverpaymentCredit = false,
  tenantName,
  disabled,
  onReceiptTotalChange,
  onAutoDistribute,
}) => {
  const { control, setValue, trigger, getValues } = useForm<ReceiptAmountFormValues>({
    defaultValues: { receiptTotalAmount },
    mode: "onChange",
  });

  useEffect(() => {
    setValue("receiptTotalAmount", receiptTotalAmount, { shouldValidate: true });
  }, [receiptTotalAmount, setValue]);

  const handleAutoDistributeClick = async () => {
    const isValid = await trigger("receiptTotalAmount");
    if (!isValid) return;

    const amount = Number(getValues("receiptTotalAmount")) || 0;
    onReceiptTotalChange(amount);
    onAutoDistribute(amount);
  };

  const amountLabel = applyOverpaymentCredit ? "Available Overpayment Credit" : "Receipt Total Amount";
  const creditHelperText = tenantName
    ? `Credit on ${tenantName}'s lease - no new receipt will be created.`
    : "Credit on this lease - no new receipt will be created.";

  return (
    <div className={styles.receiptAmountSection}>
      <div className={styles.receiptAmountRow}>
        <div className={styles.receiptAmountField}>
          <InputNumberField
            fieldname="receiptTotalAmount"
            label={amountLabel}
            isRequired
            format="currency"
            addonBefore="AED"
            control={control}
            disabled={disabled || applyOverpaymentCredit}
            onChange={(value) => onReceiptTotalChange(Number(value) || 0)}
            rules={{
              validate: (value) => {
                const amount = Number(value);
                if (value == null || Number.isNaN(amount) || amount <= 0) {
                  return getRequiredErrorMessage();
                }
                return true;
              },
            }}
            formItemProps={{ className: styles.receiptAmountFormItem }}
            inputNumberProps={{
              min: 0,
              className: applyOverpaymentCredit
                ? `${styles.receiptAmountInput} ${styles.creditAmountInput}`
                : styles.receiptAmountInput,
            }}
          />
          {applyOverpaymentCredit && <p className={styles.creditHelperText}>{creditHelperText}</p>}
        </div>
        <Button
          className="ef-reject-btn"
          htmlType="button"
          // icon={<SplitCellsOutlined />}
          disabled={disabled}
          onClick={handleAutoDistributeClick}
        >
          Auto-Distribute
        </Button>
      </div>
    </div>
  );
};
